<template>
  <div>
    <top-nav></top-nav>
    <div class="contact-page">
      <div class="contact-header">
        <h1 class="heading">{{$t('contact.contact_arcanite')}}</h1>
        <p class="subtext">{{$t('contact.contact_arcanite_desc')}}</p>
      </div>
      <div class="contact-columns">
        <div class="details-card">
          <div class="details-body">
            <h2 class="card-title">{{$t('contact.our_details')}}</h2>
            <p class="card-intro">{{$t('contact.our_details_desc')}}</p>

            <p class="label">{{$t('contact.office')}}</p>
            <p class="address">
              66 Berry Street<br>
              North Sydney NSW 2060<br>
              Australia
            </p>

            <p class="label">{{$t('contact.support')}}</p>
            <p class="support-line">
              <a href="mailto:support@arcnet.com.au" class="email-link"><span class="e-user">support</span><span class="e-at"></span><span class="e-domain">arcnet.com.au</span></a>
            </p>
            <p class="fine-print">{{$t('contact.support_desc')}}</p>

            <p class="label">{{$t('contact.new_enquire')}}</p>
            <p class="fine-print">
              {{$t('contact.new_enquire_desc1')}} <a href="mailto:support@arcnet.com.au" class="email-link"><span class="e-user">support</span><span class="e-at"></span><span class="e-domain">arcnet.com.au</span></a> {{$t('contact.new_enquire_desc2')}}
            </p>
          </div>

          <div class="details-footer">
            <div class="divider"></div>
            <p class="entity-name">Arcanite Services Pty Ltd</p>
            <p class="entity-abn">ABN 71 674 390 722</p>
          </div>
        </div>
        <div class="demo-card">
          <contact />
        </div>
      </div>
    </div>
    <foot-nav></foot-nav>
  </div>
</template>

<script>
export default {
  metaInfo: {
    script: [
      {
        vmid: 'ld-local-business',
        type: 'application/ld+json',
        json: {
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          name: 'Arcanite',
          legalName: 'Arcanite Services Pty Ltd',
          taxID: '71674390722',
          email: 'support@arcnet.com.au',
          address: {
            '@type': 'PostalAddress',
            streetAddress: '66 Berry Street',
            addressLocality: 'North Sydney',
            addressRegion: 'NSW',
            postalCode: '2060',
            addressCountry: 'AU'
          }
        }
      }
    ]
  },
  components: {
    "top-nav": () => localStorage.getItem('isPc') == 'true' ?
        import("@/components/PC/TopNav.vue") :
        import("@/components/APP/TopNav.vue"),
    "foot-nav": () => localStorage.getItem('isPc') == 'true' ?
        import("@/components/PC/FooterNav.vue") :
        import("@/components/APP/FooterNav.vue"),
    "contact": () => import("./contactForm.vue")
  }
}
</script>

<style lang="scss" scoped>
.contact-page {
  box-sizing: border-box;
  min-height: calc(100vh - 90px);
  padding: 130px 20px 80px;
  background: #F5F8FC;
  .contact-header {
    max-width: 1150px;
    margin: 0 auto 30px;
    text-align: left;
    .heading {
      font-weight: 700;
      font-size: 32px;
      color: #062440;
      margin: 0 0 12px;
    }
    .subtext {
      font-size: 16px;
      color: #67788C;
      line-height: 1.5;
      margin: 0;
    }
  }
  .contact-columns {
    max-width: 1150px;
    margin: 0 auto;
    display: flex;
    gap: 24px;
    align-items: stretch;
    flex-wrap: wrap;
  }
  .details-card, .demo-card {
    background: #fff;
    border-radius: 12px;
    padding: 32px;
    box-sizing: border-box;
    flex: 1 1 380px;
  }
  .details-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .card-title {
      font-weight: 600;
    font-size: 20px;
    color: #062440;
    margin: 0 0 8px;
  }
  .card-intro {
    font-size: 14px;
    color: #67788C;
    line-height: 1.5;
    margin: 0 0 24px;
  }
  .details-card {
    text-align: left;
    .label {
      font-weight: 600;
      font-size: 12px;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: #67788C;
      margin: 20px 0 6px;
    }
    .address, .support-line {
      font-size: 15px;
      color: #062440;
      line-height: 1.5;
      margin: 0;
    }
    .fine-print {
      font-family: Poppins;
      font-size: 13px;
      color: #67788C;
      margin: 4px 0 0;
    }
    .email-link {
      color: #1890ff;
      text-decoration: underline;
      >span {
        color: #1890ff;
      }
      .e-at::before {
        content: "\0040";
      }
    }
    .email-link:hover {
      text-decoration: underline;
    }
    .email-link:focus-visible {
      outline: 2px solid #1890ff;
      outline-offset: 2px;
    }
    .divider {
      height: 1px;
      background: #E5E6EB;
      margin: 24px 0 16px;
    }
    .entity-name {
      font-family: Poppins;
      font-size: 13px;
      color: #67788C;
      margin: 0;
      line-height: 22px;
    }
    .entity-abn {
      font-family: Poppins;
      font-size: 13px;
      color: #67788C;
      margin: 2px 0 0;
      line-height: 22px;
    }
  }
  .demo-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    ::v-deep .contact-form {
      width: 100%;
      padding: 0;
      box-shadow: none;
    }
  }
}

@media screen and (max-width: 500px) {
  .contact-page {
    padding: 100px 16px 60px;
    .contact-columns {
      flex-direction: column;
    }
    .details-card, .demo-card {
      width: 100%;
    }
    .details-card {
      padding: 24px;
      .card-title {
        font-size: 18px;
      }
      .card-intro {
        font-size: 13px;
      }
      .label {
        font-size: 11px;
        margin: 16px 0 5px;
      }
      .address, .support-line {
        font-size: 14px;
      }
      .fine-print {
        font-size: 12px;
      }
      .entity-name, .entity-abn {
        font-size: 12px;
      }
    }
  }
}
</style>
